<template>
    <div class="d-flex flex-column gap-4">
        <base-input-floating
            :label="$t('widgets.latest.preTitle')"
            :formErrors="errors"
            :rules="{required: false, max: 255}"
            name="preTitle"
            v-model="widget.content.preTitle"/>

        <base-input-floating
            :label="$t('widgets.latest.mainTitle')"
            :formErrors="errors"
            :rules="{required: false, max: 255}"
            name="mainTitle"
            v-model="widget.content.mainTitle"/>

        <WidgetIntervalSelect
            v-model="widget"
            :errors="errors"
            :organisationId="organisationId"
            @update:data="getWidgetData()"/>

        <div class="border-bottom"></div>

        <WidgetUserSelect
            v-model="widget"
            :errors="errors"
            :organisationId="organisationId"
            @update:data="getWidgetData()"/>

        <div class="border-bottom"></div>

        <WidgetEventTypeSelect
            v-model="widget"
            :errors="errors"
            :organisationId="organisationId"
            @update:data="getWidgetData()"/>
    </div>
</template>

<script setup>
import {useDashboardStore} from '~/store/dashboard';
import {getData} from "~/composables/widget";
import BaseInputFloating from "~/components/farbcode-core/Inputs/BaseInputFloating.vue";
import WidgetUserSelect from "~/components/pages/dashboards/widgets/WidgetSettings/WidgetUserSelect";
import WidgetEventTypeSelect from "~/components/pages/dashboards/widgets/WidgetSettings/WidgetEventTypeSelect";
import WidgetIntervalSelect from "~/components/pages/dashboards/widgets/WidgetSettings/WidgetIntervalSelect";

const dashboardStore = useDashboardStore()
const {t} = useI18n()

const props = defineProps({
    nodeId: {
        required: true,
        type: Number,
    },
    errors: {
        required: false,
        type: Object,
        default: {}
    },
    modelValue: {
        required: true,
        type: Object,
    },
    organisationId: {
        required: true,
        type: Number,
    }
})

const emit = defineEmits(['update:modelValue'])

const widget = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
})

function getWidgetData() {
    checkIfAuthUserSelected()
    getData(props.nodeId, dashboardStore.dashboard.token, 'latest')
}

function checkIfAuthUserSelected() {
    if (widget.value.content.userSelect === 'authenticated') {
        widget.value.content.startPosition = 1
    }
}
</script>

